export const homeComponentUrl = "/"
export const orderDataComponentUrl = "/order-data"
export const controlPlateComponentUrl = "/control-plate"
export const tyresComponentUrl = "/tyres"
export const wheelDetailsComponentUrl = "/wheel-details/"
export const completeComponentUrl = "/complete"
export const settingsComponentUrl = "/settings"
export const loginComponentUrl = "/login"